<ul><li v-for="antwort in model" :key="antwort.pos">{{ antwort.label }}</li></ul>